import { render, staticRenderFns } from "./loginToken.vue?vue&type=template&id=6f0dda98&scoped=true&"
import script from "./loginToken.vue?vue&type=script&lang=js&"
export * from "./loginToken.vue?vue&type=script&lang=js&"
import style0 from "./loginToken.vue?vue&type=style&index=0&id=6f0dda98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0dda98",
  null
  
)

export default component.exports